import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bankcreation-grid',
  templateUrl: './bankcreation-grid.component.html',
  styleUrls: ['./bankcreation-grid.component.css']
})
export class BankcreationGridComponent implements OnInit {
title="Bank Account List"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/bankcreation-grid/bankcreation-grid.component.ts